import { render, staticRenderFns } from "./EditBloc.vue?vue&type=template&id=2851e8bf&scoped=true&"
import script from "./EditBloc.vue?vue&type=script&lang=js&"
export * from "./EditBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851e8bf",
  null
  
)

export default component.exports